import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CancellationPolicyService from '../../api/services/CancellationPolicyService';
import MainPagetitle from '../../layouts/MainPagetitle';


const AddCancellationPolicy = () => {
  const navigate = useNavigate();

  const [file, setFile] = useState()
  const [error, setError] = useState([]);

  const [fields, setFields] = useState([{ i_title: '' }])
  const [defields, setdeFields] = useState([{ i_title: '' }])
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {

    }
    else {
      navigate('/')
    }
  }, []);
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var icon = fileReader.result
      setFile(icon)
    }
  }
  // ----------- Camper Inclusive ------------ //
  let addFormFields = () => {
    setFields([...fields, { i_title: '' }]);
  }
  let removeFormFields = (i) => {
    let values = [...fields];
    values.splice(i, 1);
    setFields(values)
  }
  let addGermanFormFields = () => {
    setdeFields([...defields, { i_title: '' }]);
  }
  let removeGermanFormFields = (i) => {
    let values = [...defields];
    values.splice(i, 1);
    setdeFields(values)
  }
  const onSubmitForm = async (event) => {
    event.preventDefault();

    try {
      const items = []
      const deitems =[]
      Object.keys(fields).forEach(key => items.push(fields[key].i_title))
      Object.keys(defields).forEach(key => deitems.push(defields[key].i_title))
      var userData = {
        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
        "price": event.target.price.value,
        // 'item_list': items,
        // 'de_item_list': deitems,
        "icon": file ? file.split(',')[1] : "",
      }
      console.log(userData)
      let responseData = await CancellationPolicyService.store(userData).json()
      if (responseData.status === true) {
        navigate("/admin/cancellation-policy");
      }
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }

  };

  return (
    <>
      <MainPagetitle mainTitle="Add Cancellation Policy" pageTitle={'Add Cancellation Policy'} parentTitle={'Home'} />
      <div className="container-fluid">
        <form className="form-valide" onSubmit={onSubmitForm}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Add Cancellation Policy</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Price<span className="text-danger">*</span></label>
                      <input type="number" className="form-control" name='price' id="price" placeholder="" />
                    </div>
                    {/* <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">English Item <span className="text-danger">*</span></label>
                      {fields.map((element, index) => {
                        return (
                          <div key={index}>

                            <input type="text" className="form-control mt-2" name="i_title"
                              onChange={(e) => {
                                const updatedFields = [...fields];
                                updatedFields[index].i_title = e.target.value;

                                setFields(updatedFields);
                              }}
                              value={element.i_title}
                            />
                            {
                              index ?
                                <button type="button" className="button remove mt-3 p-2" onClick={() => removeFormFields(index)}>Remove English Item</button>
                                : null
                            }

                          </div>
                        );
                      })}
                      <button className="button add mt-3 p-2 " type="button" onClick={addFormFields}>Add English Item</button>
                    </div> */}
                    {/* <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">German Item <span className="text-danger">*</span></label>
                      {defields.map((element, index) => {
                        return (
                          <div>
                            <input type="text" className="form-control mt-2" name="de_i_title"
                              onChange={(e) => {
                                const updatedFields = [...defields];
                                updatedFields[index].i_title = e.target.value;
                                setdeFields(updatedFields);
                              }}
                              value={element.i_title}
                            />
                            {
                              index ?
                                <button type="button" className="button remove mt-3 p-2" onClick={() => removeGermanFormFields(index)}>Remove</button>
                                : null
                            }
                          </div>
                        );
                      })} 
                      <button className="button add mt-3 p-2 " type="button" onClick={addGermanFormFields}>Add German Item</button>
                    </div> */}
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Icon <span className="text-danger">*</span></label>
                      <img className="img-drop-area" height={file ? 100 : 0} width={file ? 100 : 0} src={file} alt='' />
                      <input type="file" className="form-control" name='icon' id="val-number" accept="image/png, image/jpeg, image/svg+xml" onChange={onFileChange} />
                    </div>

                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                  </div>
                  <span class="span-error">{error}</span>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>

    </>
  );
};
export default AddCancellationPolicy;